import {
  Badge,
  Box,
  Checkbox,
  Collapse,
  Divider,
  Flex,
  HStack,
  Text,
  VStack,
} from '@chakra-ui/react'
import { FieldMapValue, PrenatalExamData } from '@hb/shared'
import React, { useState } from 'react'
import { SectionLabel } from '../../SectionLabel'

const GaWindowLabel: Record<string, string> = {
  'first-trimester': 'First Trimester',
  'second-trimester': 'Second Trimester',
  'third-trimester': 'Third Trimester',
  postpartum: 'Postpartum',
}

export const PatientEducationChecklistView = ({ data }: { data: FieldMapValue }) => {
  const checklist = (data as PrenatalExamData | undefined)?.patientEducationChecklist
  const [isOpen, setIsOpen] = useState(false)

  if (!checklist || checklist.items.length === 0) return null

  const checkedCount = checklist.items.filter(i => i.checked).length
  const windowLabel = GaWindowLabel[checklist.gaWindow] ?? checklist.gaWindow

  return (
    <Box w="100%">
      <Flex
        align="center"
        justify="space-between"
        cursor="pointer"
        onClick={() => setIsOpen(o => !o)}>
        <SectionLabel>Patient Education Checklist — {windowLabel}</SectionLabel>
        <HStack spacing={2}>
          <Text fontSize="xs" color="gray.500">
            {checkedCount}/{checklist.items.length} addressed
          </Text>
          <Text fontSize="xs" color="gray.400">
            {isOpen ? '▲' : '▼'}
          </Text>
        </HStack>
      </Flex>
      <Divider mt={1} />
      <Collapse in={isOpen} animateOpacity>
        <VStack align="flex-start" spacing={1} mt={2}>
          {checklist.items.map(item => (
            <Box key={item.itemId} w="100%" py={0.5}>
              <Checkbox isChecked={item.checked} isReadOnly size="sm" colorScheme="green">
                <HStack spacing={1} flexWrap="wrap">
                  {item.source === 'locked' && (
                    <Badge colorScheme="purple" fontSize="9px">
                      Required
                    </Badge>
                  )}
                  <Text fontSize="sm">{item.itemText}</Text>
                </HStack>
              </Checkbox>
              {item.checked && item.note && (
                <Text
                  fontSize="xs"
                  color="gray.600"
                  _dark={{ color: 'gray.300' }}
                  pl={6}
                  mt={0.5}
                  whiteSpace="pre-wrap">
                  {item.note}
                </Text>
              )}
            </Box>
          ))}
        </VStack>
      </Collapse>
    </Box>
  )
}
